"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var prop_types_1 = require("prop-types");

require("./index.css");

var HeaderLogo = function (_a) {
  var dataTestId = _a.dataTestId,
      width = _a.width;
  return (0, jsx_runtime_1.jsxs)("svg", __assign({
    "aria-label": "header-logo",
    height: "100%",
    viewBox: "0 0 64 64",
    width: width,
    xmlns: "http://www.w3.org/2000/svg",
    className: "header-logo",
    "data-testid": dataTestId
  }, {
    children: [(0, jsx_runtime_1.jsxs)("g", __assign({
      fill: "none",
      fillRule: "evenodd",
      className: "light-mode"
    }, {
      children: [(0, jsx_runtime_1.jsx)("path", {
        d: "M43.254 40.43c-2.056.334-3.107 1.863-3.107 4.553 0 2.707 1.4 4.517 3.547 4.517.998 0 1.906-.334 3.813-1.276v2.19c-2.29 1.056-3.637 1.384-5.482 1.384-1.997 0-3.402-.534-4.55-1.712-1.175-1.184-1.763-2.748-1.763-4.49 0-3.873 2.849-6.495 7.01-6.495 2.764 0 4.665 1.272 4.665 3.139 0 1.202-.884 2.029-2.197 2.029-.674 0-1.228-.178-1.936-.592V40.43M33.109 45.597c1.843-2.34 2.494-3.283 2.494-4.431 0-1.144-.902-2.065-2.107-2.065-.742 0-1.41.353-1.736.72v4.765l-3.02 4.05v-9.235h-2.872l-4.773 7.966v-7.966h-1.65l-4.333 1.064v1.115l2.363.24v9.77h3.055l4.579-7.573v7.574h3.345l4.655-5.994M5.988 55.425l1.981.443V57H.198v-1.132l1.77-.443V41.758H0v-1.173l4.754-1.453h1.234v1.632c2.227-1.334 2.992-1.57 4.134-1.57 2.638 0 4.584 2.449 4.584 5.84 0 3.92-2.597 6.557-6.69 6.557-.464 0-1.234-.029-2.028-.12v3.954zm0-5.339c.325.016.468.016.673.016 2.461 0 3.78-1.545 3.78-4.505 0-2.507-1.079-3.84-3.07-3.84-.332 0-.68.041-1.383.127v8.202z",
        fill: "var(--color-black)"
      }, void 0), (0, jsx_runtime_1.jsx)("path", {
        fill: "#CD4A8A",
        d: "M60.86 29.15h3.02v-5.987h-3.02z"
      }, void 0), (0, jsx_runtime_1.jsx)("path", {
        fill: "#E99A6E",
        d: "M52.509 14.177h2.334v-3.645h-2.334z"
      }, void 0), (0, jsx_runtime_1.jsx)("path", {
        fill: "#E57637",
        d: "M40.644 10.532H52.51V8.193H40.644z"
      }, void 0), (0, jsx_runtime_1.jsx)("path", {
        fill: "#DB522D",
        d: "M40.644 23.163V10.532H52.51v3.646H40.644v8.985"
      }, void 0), (0, jsx_runtime_1.jsx)("path", {
        fill: "#EA9D38",
        d: "M54.843 23.163h6.018v-8.985h-6.018z"
      }, void 0), (0, jsx_runtime_1.jsx)("path", {
        fill: "#D6372C",
        d: "M54.843 29.15h6.018v-5.987h-6.018z"
      }, void 0), (0, jsx_runtime_1.jsx)("path", {
        fill: "#DF682E",
        d: "M52.509 23.163h2.334v-8.985h-2.334z"
      }, void 0), (0, jsx_runtime_1.jsx)("path", {
        fill: "#C92E2B",
        d: "M52.509 29.15h2.334v-5.987h-2.334z"
      }, void 0), (0, jsx_runtime_1.jsx)("path", {
        fill: "#D03E2B",
        d: "M52.509 23.163h-4.445v-3h-7.42v3-8.985H52.51v8.985"
      }, void 0), (0, jsx_runtime_1.jsx)("path", {
        fill: "#B62B2C",
        d: "M48.064 29.15h4.445v-5.987h-4.445z"
      }, void 0), (0, jsx_runtime_1.jsx)("path", {
        fill: "#B2352C",
        d: "M40.644 23.164h7.42v-3h-7.42z"
      }, void 0), (0, jsx_runtime_1.jsx)("path", {
        fill: "#9A2B2A",
        d: "M40.644 29.15h7.42v-5.987h-7.42zM28.747 32.145h11.897v-2.994H28.747z"
      }, void 0)]
    }), void 0), (0, jsx_runtime_1.jsx)("g", __assign({
      fill: "none",
      fillRule: "evenodd",
      className: "dark-mode"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        d: "M60.74 28.461h2.355V23.84H60.74v4.622zm-6.172 0h5.267V23.84h-5.267v4.622zM40.373 9.765h10.695v-1.68H40.373v1.68zm11.6 3.845h1.69v-2.94h-1.69v2.94zm0 9.324h1.69v-8.42h-1.69v8.42zm0 5.527h1.69V23.84h-1.69v4.622zm-4.65 0h3.745V23.84h-3.744v4.622zm-6.95 0h6.046V23.84h-6.046v4.622zm0-13.946l.001 5.197h6.95v3.222h3.744v-8.42H40.373zm0-.905h10.695v-2.94H40.373v2.94zm0 9.324h6.046v-2.317h-6.046v2.317zm14.195 0h5.267v-8.42h-5.267v8.42zm9.432 0v6.432H39.468V7.18h12.506v2.585h2.594v3.845h6.173v9.324H64zm-36.085 9.32h11.553v-2.888H27.915v2.889zm-22.1 18.643c.771.088 1.519.116 1.968.116 3.975 0 6.498-2.544 6.498-6.325 0-3.271-1.89-5.634-4.452-5.634-1.11 0-1.852.228-4.014 1.515v-1.575H4.617L0 40.397v1.13h1.912v13.184l-1.72.428v1.092h7.547v-1.092l-1.924-.428v-3.814zm0-9.248c.682-.083 1.02-.122 1.342-.122 1.934 0 2.982 1.286 2.982 3.704 0 2.856-1.28 4.346-3.67 4.346-.2 0-.338 0-.654-.015v-7.913zm26.335 3.582c1.79-2.257 2.423-3.167 2.423-4.275 0-1.103-.876-1.99-2.046-1.99-.72 0-1.37.34-1.686.693v4.597l-2.933 3.907v-8.909H25.12l-4.636 7.685v-7.685h-1.602l-4.208 1.026v1.076l2.296.233v9.424h2.966l4.446-7.307v7.307h3.249l4.52-5.782zm9.852-4.985c-1.996.323-3.017 1.798-3.017 4.393 0 2.61 1.36 4.357 3.444 4.357.97 0 1.851-.322 3.704-1.231v2.112c-2.224 1.02-3.533 1.335-5.324 1.335-1.94 0-3.304-.515-4.418-1.65-1.142-1.143-1.713-2.651-1.713-4.331 0-3.737 2.767-6.266 6.808-6.266 2.684 0 4.53 1.226 4.53 3.027 0 1.16-.86 1.958-2.134 1.958-.655 0-1.192-.172-1.88-.57v-3.134z",
        fill: "var(--color-white)",
        fillRule: "evenodd"
      }, void 0)
    }), void 0)]
  }), void 0);
};

HeaderLogo.propTypes = {
  dataTestId: prop_types_1.string.isRequired,
  width: prop_types_1.number
};
HeaderLogo.defaultProps = {
  width: 48
};
exports.default = HeaderLogo;